// Used by the Autocomplete components, replaces Amersand generic collection
import { schema } from "normalizr";
import GenericFilter from "./generic-filter";

export const GenericFilters = new schema.Array(GenericFilter);
